import React from "react";
import { Navigate } from "react-router-dom";
import { useAccess } from "../../context/AccessContext";
import { hasModule } from "../../utils/accessHelpers";

export default function RequireModuleAccess({ moduleCode, children }) {
  const { access, loading } = useAccess();

  if (loading) {
    return <div className="p-6">Loading access...</div>;
  }

  if (!hasModule(access, moduleCode)) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}